

















































































import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {translate} from '@/services/trans'
import {getHeaderHeight, getMargin} from "@/services/margin";

@Component
export default class welcomeBuminator extends Vue {

  @Prop() isMobileView!: boolean;
  @Prop() isEnabledReferences!: boolean;
  @Prop() contactScrollTo!: string;

  public vm_x = 0
  public vw_x = 0
  public textAnimationDelay = -15
  public margin = 0

  mounted() {
    setTimeout(() => {
      if (this.isMobileView) {
        this.vm_x = -50
        this.vw_x = 0
      } else {
        setTimeout(() => {
          this.setVideoPosition()
          setTimeout(() => {
            this.setMargin();
          }, 500)
        }, 2000)
      }
    }, 2000)

    window.addEventListener('scroll', this.onScroll);

    // if (this.isMobileView) {
    //   window.addEventListener('resize', this.resize);
    //   setTimeout(() => {
    //     this.setMargin();
      // }, 300)
    // }
  }

  resize(e: any) {
    this.setMargin();
  }

  setVideoPosition() {
    setTimeout(() => {
      if (this.vm_x > -50) {
        this.vm_x = this.vm_x - 1
        this.vw_x = this.vw_x + 0.5
        this.setVideoPosition()
      }
    }, 10)
  }

  setMargin() {
    this.margin = getMargin('welcomeText', true)
  }

  trans(key: string) {
    return translate(key)
  }

  scrollToAction(elementId: string) {
    // const element: any = document.getElementById(elementId)
    // if (element != undefined) {
    //   document.getElementsByClassName('header')[0].classList.add('compact');
    //   setTimeout(() => {
    //     window.scrollTo(0, element.offsetTop + getHeaderHeight())
    //   }, 500)
    // }
    this.scrollTo(elementId, true)


  }
  onScroll(e: any) {
    const element: any = document.getElementById('welcomeBuminator')
    const elementTopPosition = element.getBoundingClientRect().top
    const elementInnerHeight = element.clientHeight
    const pageYOffset = window.pageYOffset
    const innerHeight = window.innerHeight

    if(elementTopPosition < 0 && this.downAction && !this.isMobileView){
      this.nextFrom('welcomeBuminator', false)
      this.downAction = false
      this.upAction = true
    }
    if(elementTopPosition > 0 && this.upAction && !this.isMobileView){
      this.nextFrom('welcomeBuminator', true)
      this.downAction = true
      this.upAction = false
    }
  }

  upAction = false
  downAction = true

  @Emit("scroll")
  scrollTo(name :string, isDown: boolean = false) {}

  @Emit("next")
  nextFrom(name :string, isDown: boolean = false) {}

}
